
import './Navbar.css';

export default function Navbar(){

    return(
        <header className='container-fluid'>
            <nav className='container'>
                <h2>CodeEditor</h2>
            </nav>
        </header>
    )
};